import { Box, LinearProgress, Typography } from "@mui/material"
import React from "react"

const AIProcessTips: React.FC = () => {
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        position="absolute"
        left={"35%"}
        sx={{
          backgroundColor: "transparent",
          transform: "translateX(-50%)",
          bottom: 140,
          width: "100%",
          zIndex: 1000,
          gap: 3,
        }}
      >
        <Box
          sx={{
            width: "800px",
            color: "black",
            backgroundColor: "#FFF",
            opacity: 0.6,
          }}
        >
          <LinearProgress
            color="inherit"
            sx={{ color: "black", opacity: 0.8 }}
          />
        </Box>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        position="absolute"
        top={"25%"}
        right={"2%"}
        sx={{
          margin: "auto",
          width: "28%",
          maxWidth: "468px",
          color: "white",
          padding: "10px 0",
          gap: 2,
          zIndex: 1000,
        }}
      >
        <Typography fontSize={20} width={"100%"} textAlign={"left"}>
          The AI system is preparing the case for self-planning. This may take
          up to 3 minutes.
        </Typography>

        <Typography fontSize={20}>
          You can wait for the case to reload automatically when it’s ready, or
          close the case and reopen it later from the patient list.
        </Typography>
      </Box>
    </>
  )
}

export default AIProcessTips
